import React from 'react';
// import { oneDecimal } from '../../helpers/formatters';
import { labelMatcher } from '../../helpers/label-mapper';
import styles from './region-entity-table.module.scss';
import { humanizeNumber } from '../../helpers/formatters';

//  Quick fix
const numberTypes = {
  numberOfPorts: { unit: 'number', omitDecimals: true },
  employmentFullTimeEquivalents: {
    unit: 'number',
    omitDecimals: true,
  },
  importAndExportTradeThroughput: {
    unit: 'tonnes',
    omitDecimals: true,
  },
  capitalAdditions: { unit: 'currency', omitDecimals: true },
  vesselIncome: { unit: 'currency', omitDecimals: true },
  vesselsToPort: { unit: 'full-number', omitDecimals: true },
};

export const PortInfoGrid = ({ entity, comparing }) => {
  return (
    <div className={styles.portInfoGrid}>
      <div
        className={`${styles.gridHeaderArea} ${
          comparing ? styles.comparing : 'not-comparing'
        }`}
      >
        <span className={styles.tableHeaderText}>
          {comparing ? entity.name : 'Summary'}
        </span>
      </div>
      <div
        className={`${styles.gridDataArea} ${
          comparing ? styles.comparing : 'not-comparing'
        }`}
      >
        <div className={styles.gridBoxArea}>
          {Object.entries(entity.portData)
            // Don't show ID, show key commodities at the end
            .filter(([key]) => key !== 'id' && key !== 'keyCommodities')
            .map(([key, value]) => {
              return (
                <div key={key} className={styles.gridFactBox}>
                  <div className={`${styles.tableHeaderText}`}>
                    {humanizeNumber(
                      value,
                      numberTypes[key].unit,
                      numberTypes[key].omitDecimals
                    )}
                  </div>
                  <div className={styles.dataCaption}>{labelMatcher(key)}</div>
                </div>
              );
            })}
          <div>
            <div className={styles.tableHeaderText}>
              {entity.portData['keyCommodities']}
            </div>
            <div className={styles.dataCaption}>
              {labelMatcher('keyCommodities')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/port-info-grid.js